import { RequirementInstanceResultStatus } from '@cadstrom/sigma-engine-shared';
import BackHandIcon from '@mui/icons-material/BackHand';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DangerousIcon from '@mui/icons-material/Dangerous';
import WarningIcon from '@mui/icons-material/Warning';

import { resultStatusColor } from '../constants.js';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const getStatusIcon = (status: RequirementInstanceResultStatus) => {
	const color = resultStatusColor[status] as SvgIconProps['color'];

	switch (status) {
		case RequirementInstanceResultStatus.Success: {
			return <CheckCircleIcon color={color} />;
		}
		case RequirementInstanceResultStatus.Error: {
			return <CancelIcon color={color} />;
		}
		case RequirementInstanceResultStatus.Warning: {
			return <WarningIcon color={color} />;
		}
		case RequirementInstanceResultStatus.HumanNeeded: {
			return <BackHandIcon color={color} />;
		}
		case RequirementInstanceResultStatus.Exception: {
			return <DangerousIcon color={color} />;
		}
	}
};

const getStatusTextColor = (status: RequirementInstanceResultStatus) => {
	switch (status) {
		case RequirementInstanceResultStatus.Success: {
			return 'text-green-11';
		}
		case RequirementInstanceResultStatus.Error: {
			return 'text-red-11';
		}
		case RequirementInstanceResultStatus.Warning: {
			return 'text-amber-11';
		}
		case RequirementInstanceResultStatus.HumanNeeded: {
			return 'text-orange-11';
		}
		case RequirementInstanceResultStatus.Exception: {
			return 'text-gray-11';
		}
	}
};

const getStatusLabel = (status: RequirementInstanceResultStatus) => {
	switch (status) {
		case RequirementInstanceResultStatus.Success: {
			return 'Pass';
		}
		case RequirementInstanceResultStatus.Error: {
			return 'Fail';
		}
		case RequirementInstanceResultStatus.Warning: {
			return 'Warning';
		}
		case RequirementInstanceResultStatus.HumanNeeded: {
			return 'Human Needed';
		}
		case RequirementInstanceResultStatus.Exception: {
			return 'Exception';
		}
	}
};

export type StatusBadgeProps = {
	status: RequirementInstanceResultStatus;
	size?: 'small' | 'regular'; // small is icon only, regular is icon and label
};
export function StatusBadge({ status, size = 'regular' }: StatusBadgeProps) {
	return (
		<div className={`flex items-center gap-1 uppercase ${getStatusTextColor(status)}`}>
			{getStatusIcon(status)}
			{size === 'regular' && <span>{getStatusLabel(status)}</span>}
		</div>
	);
}
